import React, { useImperativeHandle, useRef, useState } from "react";
import {
	XFactorDialog,
	AgreedNotesDialog,
	BatchPaymentMemoDialog,
	CalciumPushDialog,
	GuidanceNotesDialog,
	HundredTShirtSizeDialog,
	MeasureDayDialog,
	MemoDialog,
	NotificationDialog,
	MarketingDialog,
	ProbioticsPushDialog,
	ProteinPushDialog,
	SpecialConditionDialog,
	MemberHealthConditionDialog,
	TodoDialog,
	SpecialBodyConditionDialog,
} from "@icoach/memberDetail/dialog/index";
import { isEqual, isFunction } from "@util/utils";
import SmartRingPushDialog from "@icoach/memberDetail/dialog/SmartRingPushDialog";
import EditPaymentInfoDialog from "@icoach/memberDetail/dialog/EditPaymentInfoDialog";
import ViewPaymentDialog from "@icoach/memberDetail/dialog/ViewPaymentDialog";
import PaymentHistoryDialog from "@icoach/memberDetail/dialog/PaymentHistoryDialog";
import InactiveMemberNotificationStopDialog from "@icoach/memberDetail/dialog/InactiveMemberNotificationStopDialog";
import CheckInDialog from "@icoach/memberDetail/dialog/CheckInDialog";

const X_FACTOR_DIALOG = "XFactorDialog";
const AGREED_NOTES_DIALOG = "AgreedNotesDialog";
const MEASURE_DAY_DIALOG = "MeasureDayDialog";
const NOTIFICATION_DIALOG = "NotificationDialog";
const MARKETING_DIALOG = "MarketingDialog";
const MEMBER_DETAIL_DIALOG = "MemberDetailDialog";
const GUIDANCE_NOTES_DIALOG = "GuidanceNotesDialog";
const MEMO_DIALOG = "MemoDialog";
const SPECIAL_CONDITION_DIALOG = "SpecialConditionDialog";
const PROBIOTICS_PUSH_DIALOG = "ProbioticsPushDialog";
const PROTEIN_PUSH_DIALOG = "ProteinPushDialog";
const CALCIUM_PUSH_DIALOG = "CalciumPushDialog";
const SMART_RING_PUSH_DIALOG = "SmartRingPushDialog";
const BATCH_PAYMENT_MEMO = "BatchPaymentMemo";
const MEMBER_HEALTH_CONDITION_DIALOG = "MemberHealthConditionDialog";
const TODO_DIALOG = "TodoDialog";
const SPECIAL_BODY_CONDITION_DIALOG = "SpecialBodyConditionDialog";
const MULTIPLE_PAYMENT_DIALOG = "MultiplePaymentDialog";
const VIEW_PAYMENT_DIALOG = "ViewPaymentDialog";
const PAYMENT_HISTORY_DIALOG = "PaymentHistoryDialog";
const INACTIVE_MEMBER_NOTIFICATION_STOP_DIALOG = "InactiveMemberNotificationStopDialog";
const CHECK_IN_DIALOG = "CheckInDialog";

const MemberDetailDialogBox = React.forwardRef((props, ref) => {
	const [openDialog, setOpenDialog] = useState("");
	const [sourceData, setSourceData] = useState(null);
	const refreshRef = useRef(null);

	const handleDialogClose = () => {
		setOpenDialog(null);
		setSourceData(null);
	};

	const doRefresh = (...arg) => {
		if (isFunction(refreshRef.current)) {
			setTimeout(() => refreshRef.current(...arg), 5);
		}
	};

	useImperativeHandle(
		ref,
		() => ({
			openXFactorDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(X_FACTOR_DIALOG);
			},
			openAgreedNotesDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(AGREED_NOTES_DIALOG);
			},
			openMeasureDayDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(MEASURE_DAY_DIALOG);
			},
			openNotificationDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(NOTIFICATION_DIALOG);
			},
            openMarketingDialog: (targetDate, refreshFn) => {
                refreshRef.current = refreshFn;
                setSourceData(targetDate);
                setOpenDialog(MARKETING_DIALOG);
            },
			openHundredTShirtSizeDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(MEMBER_DETAIL_DIALOG);
			},
			openGuidanceNotesDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(GUIDANCE_NOTES_DIALOG);
			},
			openMemoDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(MEMO_DIALOG);
			},
			openSpecialConditionDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(SPECIAL_CONDITION_DIALOG);
			},
			openProbioticsPushDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(PROBIOTICS_PUSH_DIALOG);
			},
			openProteinPushDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(PROTEIN_PUSH_DIALOG);
			},
			openCalciumPushDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(CALCIUM_PUSH_DIALOG);
			},
			openSmartRingPushDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(SMART_RING_PUSH_DIALOG);
			},
			openBatchPaymentMemoDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(BATCH_PAYMENT_MEMO);
			},
			openMemberHealthConditionDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(MEMBER_HEALTH_CONDITION_DIALOG);
			},
			openTodoDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(TODO_DIALOG);
			},
			openSpecialBodyConditionDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(SPECIAL_BODY_CONDITION_DIALOG);
			},
			openViewPaymentDialog: (targetData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetData);
				setOpenDialog(VIEW_PAYMENT_DIALOG);
			},
			openMultiplePaymentDialog: (targetData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetData);
				setOpenDialog(MULTIPLE_PAYMENT_DIALOG);
			},
			openPaymentHistoryDialog: (targetData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetData);
				setOpenDialog(PAYMENT_HISTORY_DIALOG);
			},
			openInactiveMemberNotificationStopDialog: (targetData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetData);
				setOpenDialog(INACTIVE_MEMBER_NOTIFICATION_STOP_DIALOG);
			},
			openCheckInDialog: (targetData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetData);
				setOpenDialog(CHECK_IN_DIALOG);
			},
			closeDialog: () => {
				handleDialogClose();
			},
		}),
		// eslint-disable-next-line
		[],
	);

	return (
		<React.Fragment>
			<XFactorDialog open={isEqual(openDialog, X_FACTOR_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<AgreedNotesDialog open={isEqual(openDialog, AGREED_NOTES_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<MeasureDayDialog open={isEqual(openDialog, MEASURE_DAY_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<NotificationDialog open={isEqual(openDialog, NOTIFICATION_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<MarketingDialog open={isEqual(openDialog, MARKETING_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<HundredTShirtSizeDialog open={isEqual(openDialog, MEMBER_DETAIL_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<GuidanceNotesDialog open={isEqual(openDialog, GUIDANCE_NOTES_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<MemoDialog open={isEqual(openDialog, MEMO_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<SpecialConditionDialog open={isEqual(openDialog, SPECIAL_CONDITION_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<ProbioticsPushDialog open={isEqual(openDialog, PROBIOTICS_PUSH_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<ProteinPushDialog open={isEqual(openDialog, PROTEIN_PUSH_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<CalciumPushDialog open={isEqual(openDialog, CALCIUM_PUSH_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<SmartRingPushDialog open={isEqual(openDialog, SMART_RING_PUSH_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<BatchPaymentMemoDialog open={isEqual(openDialog, BATCH_PAYMENT_MEMO)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<MemberHealthConditionDialog open={isEqual(openDialog, MEMBER_HEALTH_CONDITION_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<TodoDialog open={isEqual(openDialog, TODO_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<SpecialBodyConditionDialog open={isEqual(openDialog, SPECIAL_BODY_CONDITION_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<EditPaymentInfoDialog open={isEqual(openDialog, MULTIPLE_PAYMENT_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<ViewPaymentDialog open={isEqual(openDialog, VIEW_PAYMENT_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<PaymentHistoryDialog open={isEqual(openDialog, PAYMENT_HISTORY_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<InactiveMemberNotificationStopDialog open={isEqual(openDialog, INACTIVE_MEMBER_NOTIFICATION_STOP_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<CheckInDialog open={isEqual(openDialog, CHECK_IN_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
		</React.Fragment>
	);
});

export default MemberDetailDialogBox;
